import { TaxDownPartnershipBannerCard } from '@/common/components/TaxDownPartnershipBannerCard/TaxDownPartnershipBannerCard';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { useGetDiscounts } from '@/common/integrations/menhir/employee/discounts/discounts.hooks';

export function useGetESHomeSecondaryActions() {
  const {
    features: { ff_taxdown_partnership_discount_banner },
  } = useFeatures();
  const { mealsDiscounts } = useGetDiscounts();
  const taxdownDiscount = mealsDiscounts.find((discount) =>
    discount.partnerName.toLowerCase().includes('taxdown')
  );

  return (
    ff_taxdown_partnership_discount_banner &&
    taxdownDiscount && (
      <TaxDownPartnershipBannerCard discount={taxdownDiscount} />
    )
  );
}
